import { observer } from "mobx-react";
import { h } from "preact";
import Alert from "./Alert";
function FreeDeliveryWithAddressStickyAlert(props) {
    const { freeDeliveryWithAddressStickyAlert } = props;
    const { isVisible, textMessage } = freeDeliveryWithAddressStickyAlert;
    if (!isVisible || textMessage === null) {
        return null;
    }
    return (h(Alert, { type: "info", variant: "toast", message: textMessage, onClose: () => freeDeliveryWithAddressStickyAlert.markAsClosed() }));
}
export default observer(FreeDeliveryWithAddressStickyAlert);
